// Written in this round about way for babel-transform-imports
import Switch from "react-router/es/Switch";

export default Switch;


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/es/Switch.js
// module id = 1295
// module chunks = 0